import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Group, Rect } from 'react-konva'
import { updateCursor } from '../../../../../helpers/media'
import { Rectangle, Position } from '../../../../../helpers/math'

export class Selection extends Component
{
    static propTypes = {
        imageRect: PropTypes.instanceOf(Rectangle).isRequired,
        rotation: PropTypes.number.isRequired,
        computeMousePositionRelativeToImage: PropTypes.func.isRequired,
        setCollaborativeIndexationCreationZone: PropTypes.func.isRequired,
        frame: PropTypes.instanceOf(Rectangle).isRequired,
    }

    constructor(props)
    {
        super(props)

        this.onMouseDown = this.onMouseDown.bind(this)
        this.onMouseMove = this.onMouseMove.bind(this)
        this.onTouchStart = this.onTouchStart.bind(this)
        this.onTouchMove = this.onTouchMove.bind(this)
        this.startDrawingSelection = this.startDrawingSelection.bind(this)
        this.drawingSelection = this.drawingSelection.bind(this)
        this.stopDrawingSelection = this.stopDrawingSelection.bind(this)
        this.mousePosition = this.mousePosition.bind(this)
        this.touchPosition = this.touchPosition.bind(this)
        this.createIndexationZone = this.createIndexationZone.bind(this)

        this.state = {
            drawing: false,
            selection: new Rectangle(0, 0, new Position(0, 0))
        }
    }

    onMouseDown(event)
    {
        this.startDrawingSelection(this.mousePosition(event))
    }

    onMouseMove(event)
    {
        this.drawingSelection(this.mousePosition(event))
    }

    onTouchStart(event)
    {
        this.startDrawingSelection(this.touchPosition(event))
    }

    onTouchMove(event)
    {
        this.drawingSelection(this.touchPosition(event))
    }

    startDrawingSelection(position)
    {
        if(this.state.drawing === true)
        {
            this.createIndexationZone()
        }

        this.setState({
            drawing: true,
            selection: new Rectangle(0, 0, position)
        })
    }

    drawingSelection(position)
    {
        const { offset, imageRect } = this.props
        const { selection, drawing } = this.state

        if(! drawing)
        {
            return
        }

        position = new Position(
            Math.max(
                Math.min(position.x, imageRect.width / 2 + offset.x + imageRect.position.x),
                (offset.x + imageRect.position.x) - imageRect.width / 2
            ),
            Math.max(
                Math.min(position.y, imageRect.height / 2 + offset.y + imageRect.position.y),
                (offset.y + imageRect.position.y) - imageRect.height / 2
            ),
        )

        this.setState({
            selection: new Rectangle(
                position.x - selection.position.x,
                position.y - selection.position.y,
                selection.position.duplicate()
            )
        })
    }

    stopDrawingSelection()
    {
        if(this.state.drawing === true)
        {
            this.createIndexationZone()
        }
    }

    createIndexationZone()
    {
        this.setState({
            drawing: false,
        })

        this.props.setCollaborativeIndexationCreationZone(this.state.selection)
    }

    mousePosition(event)
    {
        return this.props.computeMousePositionRelativeToImage(new Position(event.evt.offsetX, event.evt.offsetY))
    }

    touchPosition(event)
    {
        const pointerPosition = event.target.getStage().getPointerPosition()

        return this.props.computeMousePositionRelativeToImage(new Position(pointerPosition.x, pointerPosition.y))
    }

    render()
    {
        const { offset, imageRect, frame, rotation } = this.props
        const { selection } = this.state

        return (
            <Group
                onMouseMove={this.onMouseMove}
                onTouchMove={this.onTouchMove}
                onMouseUp={this.stopDrawingSelection}
                onTouchEnd={this.stopDrawingSelection}
                onMouseLeave={this.stopDrawingSelection}
            >
                <Rect width={frame.width} height={frame.height} offset={{x: frame.width / 2, y: frame.height / 2}} />
                <Group
                    onMouseDown={this.onMouseDown}
                    onTouchStart={this.onTouchStart}
                    onMouseEnter={updateCursor('crosshair')}
                    onMouseLeave={updateCursor('default')}
                    rotation={rotation}
                >
                    <Rect width={imageRect.width} height={imageRect.height} offset={{ ...offset }} />
                    <Rect
                        offset={{ ...offset }}
                        width={selection.width}
                        height={selection.height}
                        position={selection.position}
                        stroke={'#61B9BF'}
                        fill={'rgba(97, 185, 191, 0.18)'}
                    />
                </Group>
            </Group>

        )
    }
}
